import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteVehicleTypeGroup(
  uuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/vehicle-type-group/${uuid}`)
}
